<template>
  <div>
    <main-template>
      <v-row>
        <v-col>
          <h1>
            <v-btn
              color="primary"
              x-small
              text
              @click="() => $router.push({ name: 'aulas' })"
              :disabled="submittingForm"
            >
              <v-icon left> fa fa-angle-left </v-icon>
            </v-btn>
            Lançando Frequências
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="aula">
          <v-card color="green lighten-1" class="mb-5" outlined>
            <v-card-title> Professor: {{ aula.professor.nome }} </v-card-title>
            <v-card-subtitle class="font-weight-medium">
              <div>Turma: {{ aula.turma.descricao }}</div>
              <div v-if="aula.disciplina">
                Componente Curricular: {{ aula.disciplina?.descricao }}
              </div>
              <div v-else>
                <div v-for="(item, index) in aula.disciplinas" :key="index">
                  <v-chip x-small>{{ getNomeDisciplina(item) }} </v-chip>
                </div>
              </div>
              <div>Data: {{ aula.data_formatada }}</div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="aula && presencas.length">
        <v-col cols="12">
          <v-card class="mb-4">
            <v-card-title class="py-2">
              <v-icon class="mr-2">palette</v-icon>
              Legenda
            </v-card-title>
            <v-card-text class="py-2">
              <v-row>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center mb-2">
                    <div class="color-box red lighten-4 mr-3"></div>
                    <span class="text-caption">Situação adversa na matrícula</span>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center mb-2">
                    <div class="color-box blue_light mr-3"></div>
                    <span class="text-caption">Aluno com necessidades especiais (PcD)</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-simple-table class="elevation-1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Aluno</th>
                  <th class="text-left">Presença</th>
                  <th class="text-left">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="presenca of presencas"
                  :key="presenca.matricula_id"
                  :class="getRowClass(presenca)"
                >
                  <td class="font-weight-medium">
                    <div>
                      {{
                        presenca.matricula.aluno
                          ? presenca.matricula.aluno.nomecompleto
                          : `[ALUNO POSSIVELMENTE DELETADO] MATRICULA: ${presenca.matricula.id}`
                      }}
                      <v-chip
                        label
                        color="error"
                        small
                        v-if="
                          $constants.situacoesMatriculaCondition[
                            removerEspaco(
                              presenca.matricula.situacao ? presenca.matricula.situacao : ''
                            )
                          ]
                        "
                        >{{ presenca.matricula.situacao }}</v-chip
                      >
                    </div>
                    <div>
                      <small>
                        {{
                          presenca.matricula.aluno ? presenca.matricula.aluno.codigo_inep : "- - -"
                        }}
                        /
                        {{ presenca.matricula.aluno ? presenca.matricula.aluno.codigo : "- - -" }}
                      </small>
                    </div>
                  </td>
                  <td>
                    <v-btn-toggle
                      :value="presenca.presente ? 0 : 1"
                      v-if="presenca.matricula.aluno"
                    >
                      <v-btn
                        v-if="
                          !$constants.situacoesMatriculaCondition[
                            removerEspaco(
                              presenca.matricula.situacao ? presenca.matricula.situacao : ''
                            )
                          ]
                        "
                        @click="
                          aula.presencas_confirmadas
                            ? mostrarAvisoConfirmado()
                            : atualizarFrequencia(presenca, true)
                        "
                        :color="presenca.presente ? 'green' : 'grey lighten-2'"
                        :style="aula.presencas_confirmadas ? 'opacity: 0.5;' : ''"
                        small
                      >
                        <v-icon :class="presenca.presente ? 'white--text' : ''" x-small>
                          fa fa-thumbs-up
                        </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="
                          !$constants.situacoesMatriculaCondition[
                            removerEspaco(
                              presenca.matricula.situacao ? presenca.matricula.situacao : ''
                            )
                          ]
                        "
                        @click="
                          aula.presencas_confirmadas
                            ? mostrarAvisoConfirmado()
                            : atualizarFrequencia(presenca, false)
                        "
                        :color="!presenca.presente ? 'red' : 'grey lighten-2'"
                        :style="aula.presencas_confirmadas ? 'opacity: 0.5;' : ''"
                        small
                      >
                        <v-icon :class="!presenca.presente ? 'white--text' : ''" x-small>
                          fa fa-thumbs-down</v-icon
                        >
                      </v-btn>
                    </v-btn-toggle>
                  </td>
                  <td>
                    <v-chip
                      v-if="!presenca.presente && presenca.justificativa_id"
                      x-small
                      color="green"
                      text-color="white"
                    >
                      Falta justificada
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col>
          <v-card class="elevation-2 pa-4 rounded-lg">
            <div class="d-flex justify-space-between align-center flex-wrap">
              <div class="d-flex flex-column flex-sm-row align-start align-sm-center flex-wrap">
                <div class="instruction-text mb-2 mb-sm-0 mr-sm-4">
                  <v-icon small class="mr-2 text--secondary">mdi-information-outline</v-icon>
                  <span class="text-body-2 font-weight-medium">
                    Verifique as presenças antes de confirmar
                  </span>
                </div>

                <div class="legend-container d-flex align-center flex-wrap">
                  <span class="text-caption text--secondary mr-3 font-weight-medium">Legenda:</span>

                  <div class="legend-item d-flex align-center mr-4">
                    <v-chip x-small color="green" text-color="white" class="mr-1 pa-3">
                      <v-icon x-small left>fa fa-thumbs-up</v-icon>
                      Presença
                    </v-chip>
                  </div>

                  <div class="legend-item d-flex align-center">
                    <v-chip x-small color="red" text-color="white" class="mr-1 pa-3">
                      <v-icon x-small left>fa fa-thumbs-down</v-icon>
                      Falta
                    </v-chip>
                  </div>
                </div>
              </div>

              <div class="action-container mt-3 mt-sm-0">
                <v-btn
                  :color="aula.presencas_confirmadas ? 'green' : 'primary'"
                  :outlined="!aula.presencas_confirmadas"
                  :depressed="aula.presencas_confirmadas"
                  elevation="0"
                  class="font-weight-medium"
                  @click="abrirModalConfirmacao"
                  :style="aula.presencas_confirmadas ? 'pointer-events:none;' : ''"
                  dark
                >
                  <v-icon left class="mr-1">
                    {{
                      aula.presencas_confirmadas ? "mdi-check-circle" : "mdi-check-circle-outline"
                    }}
                  </v-icon>

                  <span>
                    {{ aula.presencas_confirmadas ? "Confirmado" : "Confirmar Frequência" }}
                  </span>
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-alert v-else color="primary" outlined prominent text type="warning">
        Sem matriculas cadastradas para essa turma.
      </v-alert>
      <v-snackbar
        dense
        :value="exibirSnackbar"
        :timeout="-1"
        class="mb-12"
        :color="snackbarColor"
        right
        bottom
      >
        <div v-if="promisesCount > 0" class="d-flex align-center">
          <v-progress-circular indeterminate size="25" color="white"></v-progress-circular>
          <span class="ml-2 font-weight-medium">Salvando dados de frequência no servidor</span>
          <v-btn @click="fecharSnackbar" class="ml-2" icon
            ><v-icon small>fa fa-close</v-icon></v-btn
          >
        </div>
        <div v-else-if="errorMessages.length == 0" class="d-flex align-center">
          <v-icon size="20" color="white">fa fa-check</v-icon>
          <span class="ml-2 font-weight-medium">Dados de frequência salvos no servidor!</span>
          <v-btn @click="fecharSnackbar" class="ml-2" icon
            ><v-icon small>fa fa-close</v-icon></v-btn
          >
        </div>
        <div v-else class="d-flex align-center">
          <v-icon size="20" color="white">fa fa-exclamation-circle</v-icon>
          <span class="ml-2 font-weight-medium">Erro ao salvar dados de frequência!</span>
          <v-btn @click="fecharSnackbar" class="ml-2" icon
            ><v-icon small>fa fa-close</v-icon></v-btn
          >
        </div>
      </v-snackbar>
      <!-- Mantenha seu ModalConfirmacao existente -->
      <ModalConfirmacao
        v-model="showConfirmacaoModal"
        titulo="Confirmar Frequência"
        acao="confirmar a frequência desta aula"
        icon="mdi-account-check"
        icon-color="primary"
        texto-confirmar="Sim, Confirmar"
        cor-botao-confirmar="success"
        icone-botao-confirmar="mdi-check-circle"
        aviso-tipo="info"
        ref="modalConfirmacao"
        @confirmado="confirmarFrequencia"
      />
    </main-template>
  </div>
</template>

<script>
import ModalConfirmacao from "../../components/EModalConfirmacao.vue";

export default {
  props: {
    aula_id: {
      type: [String, Number],
      required: true,
    },
  },

  components: {
    ModalConfirmacao,
  },

  mounted() {
    this.loadBasicData();
    this.getDisciplinas();
  },

  data() {
    return {
      disciplinas: [],
      submittingForm: false,
      aula: null,
      presencas: [],
      exibirSnackbar: false,
      promisesCount: 0,
      errorMessages: [],

      matriculaSelect: {},
      showConfirmacaoModal: false,
    };
  },

  computed: {
    snackbarColor() {
      if (this.errorMessages.length > 0) return "error";
      return this.promisesCount > 0 ? "info" : "success";
    },
  },

  methods: {
    async getDisciplinas() {
      this.disciplinas = await this.$services.disciplinasService.syncAll();
    },

    getNomeDisciplina(id) {
      const discplina = this.disciplinas.filter((obj) => obj.id === id);
      return discplina[0].descricao;
    },

    async loadBasicData() {
      this.$loaderService.open("Carregando dados...");

      try {
        const aula = await this.$services.aulasService.getAulaComRelacoes(this.aula_id);
        this.aula = aula;

        this.presencas = aula.turma.matriculas.map((matricula) => {
          const faltou =
            this.aula.faltas.filter(
              (falta) => parseInt(falta.matricula_id, 10) === parseInt(matricula.id, 10)
            ).length > 0;

          const falta = this.aula.faltas.filter(
            (falta) => parseInt(falta.matricula_id, 10) === parseInt(matricula.id, 10)
          );

          return {
            matricula,
            matricula_id: matricula.id,
            presente: !faltou,
            document: falta[0] ? falta[0].document : null,
            justificativa_id: falta[0] ? falta[0].justificativa_id : null,
          };
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async atualizarFrequencia(frequencia, novoEstado) {
      frequencia.presente = novoEstado;
      this.exibirSnackbar = true;
      this.promisesCount += 1;
      try {
        await this.$services.aulasService.registrarPresenca(this.aula, frequencia);
      } catch (error) {
        this.errorMessages.push(error.message);
        this.$handleError(error);
      }
      this.promisesCount -= 1;
    },
    fecharSnackbar() {
      this.exibirSnackbar = false;
      this.errorMessages = [];
    },
    removerEspaco(string) {
      return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },
    async confirmarFrequencia() {
      this.$refs.modalConfirmacao.setLoading(true);

      try {
        await this.$services.aulasService.confirmarFrequencia(parseInt(this.aula.id, 10));
        this.$toast.success("Frequência confirmada com sucesso");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
        this.showConfirmacaoModal = true;
      } finally {
        this.$refs.modalConfirmacao.setLoading(false);
      }
    },

    abrirModalConfirmacao() {
      this.showConfirmacaoModal = true;
    },
    mostrarAvisoConfirmado() {
      this.$toast.warn("Não é possível alterar a frequência após confirmar as presenças.");
    },
    getRowClass(presenca) {
      const situacaoAdversa =
        this.$constants.situacoesMatriculaCondition[
          this.removerEspaco(presenca.matricula?.situacao ? presenca.matricula?.situacao : "")
        ];

      const especial = presenca.matricula?.aluno.especial;

      if (situacaoAdversa && especial) {
        return "red lighten-4";
      }

      if (situacaoAdversa) {
        return "red lighten-4";
      }

      if (especial) {
        return "blue_light";
      }

      return "";
    },
  },
};
</script>
